{
  "version": 1,
  "asset_id": "11d677ec-2d56-4b24-8bc1-f57bc464a73a",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/11d677ec-2d56-4b24-8bc1-f57bc464a73a/over-ons-1024.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/11d677ec-2d56-4b24-8bc1-f57bc464a73a/over-ons-1024.avif",
  "original_filename": "over-ons-1024.avif",
  "size": 49741,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:03:48Z"
}
